/* ============================================================
   custom-collage.js  —  Spark Store Custom Photo Collage Poster
   ============================================================ */
(function () {
  'use strict';

  /* ── CONFIG ───────────────────────────────────────────── */
  var SIZE_CONFIG = {
    '20*30': { ratio: 'cc-ratio-2-3', wCm: 20, hCm: 30 },
    '30*40': { ratio: 'cc-ratio-3-4', wCm: 30, hCm: 40 },
    '40*50': { ratio: 'cc-ratio-4-5', wCm: 40, hCm: 50 },
    '50*70': { ratio: 'cc-ratio-5-7', wCm: 50, hCm: 70 },
  };
  var DEFAULT_SIZE = '20*30';
  var SAFE_CM      = 1.25;
  var MIN_DPI      = 150;
  var TOTAL_STEPS  = 4;
  var GAP_PX       = 3;
  var PAD_PX       = 16;

  var FILTER_CSS = {
    bw:    'grayscale(100%)',
    sepia: 'sepia(80%)',
    color: 'none',
  };

  function filteredCanvas(img, dw, dh, filter) {
    var tmp = document.createElement('canvas');
    tmp.width  = Math.ceil(dw);
    tmp.height = Math.ceil(dh);
    var tCtx = tmp.getContext('2d');
    tCtx.drawImage(img, 0, 0, dw, dh);
    if (filter === 'color') return tmp;

    var imageData = tCtx.getImageData(0, 0, tmp.width, tmp.height);
    var d = imageData.data;
    for (var i = 0; i < d.length; i += 4) {
      var r = d[i], g = d[i+1], b = d[i+2];
      if (filter === 'bw') {
        var l = 0.299*r + 0.587*g + 0.114*b;
        d[i] = d[i+1] = d[i+2] = l;
      } else if (filter === 'sepia') {
        d[i]   = Math.min(255, r*0.769 + g*0.686 + b*0.534 * 0.8 + r*0.2);
        d[i+1] = Math.min(255, r*0.349 + g*0.686 + b*0.168 * 0.8 + g*0.2);
        d[i+2] = Math.min(255, r*0.272 + g*0.534 + b*0.131 * 0.8 + b*0.2);
      }
    }
    tCtx.putImageData(imageData, 0, 0);
    return tmp;
  }

  var BG_CONFIG = {
    white: { bg: '#ffffff', text: '#1a1a1a', muted: '#555555', cell: '#e8e5e0' },
    black: { bg: '#1a1a1a', text: '#f5f5f0', muted: '#aaaaaa', cell: '#2e2e2e' },
    ivory: { bg: '#f5f0e8', text: '#2a2015', muted: '#7a6e5f', cell: '#e0d8cc' },
  };

  /* ── STATE ────────────────────────────────────────────── */
  var photos = new Array(12).fill(null);
  var state = {
    step: 1,
    filter: 'bw',
    bg: 'white',
    gridCount: 9,
    selectedOptions: {},
    currentSize: DEFAULT_SIZE,
    adjustIdx: -1,
  };
  var drag = { active:false, startX:0, startY:0, startPanX:0, startPanY:0 };
  var adjustCanvas = null, adjustCtx = null, adjustImg = null;
  var watermarkRaf = null;

  function g(id)    { return document.getElementById(id); }
  function clamp(v) { return Math.max(-1, Math.min(1, v)); }
  function safePx(px, cm) { return (SAFE_CM / cm) * px; }

  /* ── SPINNER ──────────────────────────────────────────── */
  function showSpinner(btn) {
    var orig = btn.innerHTML;
    btn.innerHTML =
      '<span style="display:inline-flex;align-items:center;gap:8px;">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" style="animation:cc-spin 0.7s linear infinite;flex-shrink:0;">' +
      '<circle cx="8" cy="8" r="6" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>' +
      '<path d="M8 2 A6 6 0 0 1 14 8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<span id="cc-spin-label">Working…</span></span>';
    btn.disabled = true; btn.dataset.sparkBusy = '1';
    return {
      label:   function(t){ var l=g('cc-spin-label'); if(l) l.textContent=t; },
      restore: function(){ btn.innerHTML=orig; btn.disabled=false; delete btn.dataset.sparkBusy; },
    };
  }

  /* ── INIT ─────────────────────────────────────────────── */
  function init() {
    if (!g('cc-product-form')) return;
    if (!g('cc-spin-style')) {
      var st = document.createElement('style');
      st.id = 'cc-spin-style';
      st.textContent = '@keyframes cc-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }
    adjustCanvas = g('cc-adjust-canvas');
    if (adjustCanvas) adjustCtx = adjustCanvas.getContext('2d');

    document.querySelectorAll('.cc-pill.active[data-option]').forEach(function(p){
      state.selectedOptions[p.dataset.option] = p.dataset.value;
      if (p.dataset.value in SIZE_CONFIG) state.currentSize = p.dataset.value;
    });

    // Mark mandatory fields with a star
    ['cc-name1','cc-name2','cc-headline'].forEach(function(id) {
      var el = g(id); if (!el) return;
      var label = el.closest('.cc-field') && el.closest('.cc-field').querySelector('label');
      if (label && !label.querySelector('.cc-required')) {
        var star = document.createElement('span');
        star.className = 'cc-required'; star.textContent = '*';
        label.appendChild(star);
      }
    });

    bindEvents();
    updatePreview();
    resolveVariant();
    goToStep(1);
    scheduleWatermark();
  }

  /* ── STEPPER ──────────────────────────────────────────── */
  function goToStep(n) {
    state.step = n;
    for (var i=1; i<=TOTAL_STEPS; i++) {
      var el = g('cc-step-'+i);
      if (el) el.style.display = (i===n) ? '' : 'none';
    }
    var fill = g('cc-progress-fill');
    if (fill) fill.style.width = ((n/TOTAL_STEPS)*100)+'%';
    document.querySelectorAll('.cc-step-labels span').forEach(function(s){
      s.classList.toggle('active', parseInt(s.dataset.step)===n);
    });
    var btnPrev = g('cc-btn-prev'), btnNext = g('cc-btn-next');
    if (btnPrev) btnPrev.style.visibility = (n===1) ? 'hidden' : 'visible';
    if (btnNext) {
      if (n===TOTAL_STEPS) { btnNext.style.display='none'; }
      else { btnNext.style.display=''; btnNext.textContent = (n===TOTAL_STEPS-1) ? 'Review →' : 'Next →'; }
    }
    if (n===TOTAL_STEPS) buildReview();
    hideError();
  }

  /* ── VALIDATION ───────────────────────────────────────── */
  function validateStep(n) {
    if (n === 1) {
      var missing = [];
      for (var i=0; i<state.gridCount; i++) { if (!photos[i]) missing.push(i+1); }
      if (missing.length > 0) {
        for (var j=0; j<state.gridCount; j++) {
          var cell = document.querySelector('.cc-cell[data-idx="'+j+'"]');
          if (cell) { cell.classList.remove('cc-cell--missing'); void cell.offsetWidth; if(!photos[j]) cell.classList.add('cc-cell--missing'); }
        }
        showError(missing.length===1
          ? 'Please upload photo '+missing[0]+' before continuing.'
          : 'Please upload all '+state.gridCount+' photos. Still missing: '+missing.join(', ')+'.');
        return false;
      }
    }
    if (n === 2) {
      // BUG FIX: validate mandatory text fields
      var name1 = (g('cc-name1') && g('cc-name1').value.trim()) || '';
      var name2 = (g('cc-name2') && g('cc-name2').value.trim()) || '';
      var headline = (g('cc-headline') && g('cc-headline').value.trim()) || '';
      if (!name1 || !name2) {
        if (!name1 && g('cc-name1')) g('cc-name1').classList.add('cc-field--error');
        if (!name2 && g('cc-name2')) g('cc-name2').classList.add('cc-field--error');
        showError('Please enter both names before continuing.');
        return false;
      }
      if (!headline) {
        if (g('cc-headline')) g('cc-headline').classList.add('cc-field--error');
        showError('Please enter a headline before continuing.');
        return false;
      }
    }
    return true;
  }

  /* ── GRID COUNT ───────────────────────────────────────── */
  function setGridCount(n) {
    state.gridCount = n;
    for (var i=0; i<12; i++) {
      var cell = document.querySelector('.cc-cell[data-idx="'+i+'"]');
      if (cell) {
        cell.classList.toggle('cc-cell--hidden', i>=n);
        cell.classList.remove('cc-cell--missing');
      }
    }
    var pg = g('cc-poster-grid');
    if (pg) pg.classList.toggle('cc-grid-12', n===12);
    for (var k=0; k<12; k++) {
      var pc = g('cc-poster-cell-'+k);
      if (pc) pc.classList.toggle('cc-poster-cell--hidden', k>=n);
    }
    var tc = g('cc-trigger-count'),  tc2 = g('cc-trigger-count2');
    var ut = g('cc-upload-total');
    if (tc)  tc.textContent  = n;
    if (tc2) tc2.textContent = n;
    if (ut)  ut.textContent  = n;
    var tb = g('cc-upload-trigger');
    if (tb) tb.innerHTML = '📂 &nbsp;Choose <span id="cc-trigger-count">'+n+'</span> Photos';
    var hint = document.querySelector('.cc-upload-trigger-hint');
    if (hint) hint.innerHTML = 'All photos open at once — select exactly <span id="cc-trigger-count2">'+n+'</span>';
    var prop = g('cc-prop-grid');
    if (prop) prop.value = n===12 ? '3x4 (12 photos)' : '3x3 (9 photos)';
    updateUploadCount();
    scheduleWatermark();
  }

  /* ── REVIEW ───────────────────────────────────────────── */
  function buildReview() {
    var v = getValues();
    var uploaded = 0;
    for (var i=0; i<state.gridCount; i++) { if (photos[i]) uploaded++; }
    var summary = g('cc-review-summary'); if (!summary) return;
    var fl = {bw:'Black & White', sepia:'Sepia', color:'Color'}[state.filter] || state.filter;
    var bl = state.bg.charAt(0).toUpperCase()+state.bg.slice(1);
    var lines = [
      ['Photos',     uploaded+' / '+state.gridCount],
      ['Grid',       state.gridCount===12 ? '3 × 4 (12 photos)' : '3 × 3 (9 photos)'],
      ['Names',      v.names],
      ['Date',       v.date],
      ['Headline',   v.headline],
      ['Subline',    v.subline],
      ['Filter',     fl],
      ['Background', bl],
      ['Size',       state.currentSize+' cm'],
    ];
    summary.innerHTML = lines.map(function(l){ return '<div><strong>'+l[0]+'</strong>'+(l[1]||'—')+'</div>'; }).join('');
    var p = function(id,val){ var el=g(id); if(el) el.value=val; };
    p('cc-prop-names',    v.names);
    p('cc-prop-date',     v.date);
    p('cc-prop-headline', v.headline);
    p('cc-prop-subline',  v.subline);
    p('cc-prop-filter',   fl);
    p('cc-prop-bg',       bl);
    p('cc-prop-grid',     state.gridCount===12 ? '3x4 (12 photos)' : '3x3 (9 photos)');
  }

  /* ── EVENTS ───────────────────────────────────────────── */
  function bindEvents() {
    ['cc-name1','cc-name2','cc-sep','cc-date','cc-headline','cc-subline'].forEach(function(id){
      var el=g(id); if(!el) return;
      el.addEventListener('input', updatePreview);
      // Clear error state as soon as the user starts typing
      el.addEventListener('input', function(){ this.classList.remove('cc-field--error'); });
    });

    document.querySelectorAll('.cc-count-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        document.querySelectorAll('.cc-count-btn').forEach(function(b){ b.classList.remove('active'); });
        this.classList.add('active');
        setGridCount(parseInt(this.dataset.count));
      });
    });

    var trigger = g('cc-upload-trigger');
    var bulkInput = g('cc-bulk-input');
    if (trigger && bulkInput) {
      trigger.addEventListener('click', function(){ bulkInput.click(); });
      bulkInput.addEventListener('change', function(){
        var files = Array.from(this.files).filter(function(f){ return f.type.startsWith('image/') || /\.hei[cf]$/i.test(f.name); });
        if (files.length === 0) return;
        var grid = g('cc-photo-grid'), prog = g('cc-upload-progress');
        if (grid) grid.style.display = '';
        if (prog) prog.style.display = '';
        var queue = files.slice(0, state.gridCount);
        function processNext(i) {
          if (i >= queue.length) {
            if (queue.length < state.gridCount) {
              showError('You selected '+queue.length+' photos but need '+state.gridCount+'. Please upload the remaining '+(state.gridCount-queue.length)+'.');
            } else {
              hideError();
            }
            return;
          }
          handlePhotoQueued(i, queue[i], function(){ processNext(i + 1); });
        }
        processNext(0);
      });
    }

    var shuffleBtn = g('cc-shuffle-btn');
    if (shuffleBtn) shuffleBtn.addEventListener('click', shufflePhotos);

    document.querySelectorAll('.cc-replace-input').forEach(function(input){
      input.addEventListener('change', function(){
        var idx = parseInt(this.dataset.idx);
        var file = this.files[0];
        if (file && file.type.startsWith('image/')) handlePhoto(idx, file);
      });
    });

    document.addEventListener('click', function(e){
      var btn = e.target.closest('.cc-ctrl-btn');
      if (!btn) return;
      var idx = parseInt(btn.dataset.idx);
      if (btn.classList.contains('cc-ctrl-replace')) {
        var inp = g('cc-replace-'+idx);
        if (inp) inp.click();
        return;
      }
      if (btn.classList.contains('cc-ctrl-adjust')) {
        openAdjustModal(idx);
        return;
      }
    });

    initDragDrop();

    var filterRow = g('cc-filter-row');
    if (filterRow) filterRow.addEventListener('click', function(e){
      var btn = e.target.closest('.cc-filter-btn'); if (!btn) return;
      document.querySelectorAll('.cc-filter-btn').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      state.filter = btn.dataset.filter;
      applyFilterToAll();
    });

    var bgRow = g('cc-bg-row');
    if (bgRow) bgRow.addEventListener('click', function(e){
      var btn = e.target.closest('.cc-bg-btn'); if (!btn) return;
      document.querySelectorAll('.cc-bg-btn').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      state.bg = btn.dataset.bg;
      applyBackground();
    });

    document.querySelectorAll('.cc-pill[data-option]').forEach(function(pill){
      pill.addEventListener('click', function(){
        if (this.classList.contains('unavailable')) return;
        var opt = this.dataset.option;
        document.querySelectorAll('.cc-pill[data-option="'+opt+'"]').forEach(function(p){ p.classList.remove('active'); });
        this.classList.add('active');
        state.selectedOptions[opt] = this.dataset.value;
        if (this.dataset.value in SIZE_CONFIG) { state.currentSize=this.dataset.value; updatePosterRatio(this.dataset.value); }
        resolveVariant();
      });
    });

    var btnNext=g('cc-btn-next'), btnPrev=g('cc-btn-prev');
    if (btnNext) btnNext.addEventListener('click', function(){ if(!validateStep(state.step)) return; if(state.step<TOTAL_STEPS) goToStep(state.step+1); });
    if (btnPrev) btnPrev.addEventListener('click', function(){ if(state.step>1) goToStep(state.step-1); });

    var adjustClose=g('cc-adjust-close'), adjustApply=g('cc-adjust-apply'), panReset=g('cc-pan-reset');
    if (adjustClose) adjustClose.addEventListener('click', closeAdjustModal);
    if (adjustApply) adjustApply.addEventListener('click', closeAdjustModal);
    if (panReset) panReset.addEventListener('click', function(){
      if (state.adjustIdx<0||!photos[state.adjustIdx]) return;
      photos[state.adjustIdx].panX=0; photos[state.adjustIdx].panY=0;
      drawAdjustCanvas(); applyPanToPreview(state.adjustIdx);
    });
    document.querySelectorAll('.cc-arrow-btn[data-dx]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (state.adjustIdx<0||!photos[state.adjustIdx]) return;
        var dx=parseFloat(this.dataset.dx), dy=parseFloat(this.dataset.dy);
        if (!dx&&!dy) return;
        var p=photos[state.adjustIdx];
        p.panX=clamp(p.panX-dx*0.08); p.panY=clamp(p.panY-dy*0.08);
        drawAdjustCanvas(); applyPanToPreview(state.adjustIdx);
      });
    });

    if (adjustCanvas) {
      adjustCanvas.addEventListener('mousedown',  onDragStart);
      adjustCanvas.addEventListener('touchstart', onDragStart, {passive:true});
    }
    window.addEventListener('mousemove', onDragMove);
    window.addEventListener('mouseup',   onDragEnd);
    var modal = g('cc-adjust-modal');
    if (modal) {
      modal.addEventListener('touchmove', onDragMove, {passive:false});
      modal.addEventListener('touchend',  onDragEnd,  {passive:true});
    }

    if (window.ResizeObserver) {
      var poster=g('cc-poster');
      if (poster) new ResizeObserver(scheduleWatermark).observe(poster);
    }
    var form=g('cc-product-form');
    if (form) form.addEventListener('submit', handleSubmit);
  }

  /* ── PHOTO ────────────────────────────────────────────── */
  function handlePhotoQueued(idx, file, done) {
    var isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
                 /\.hei[cf]$/i.test(file.name);
    if (isHeic) {
      convertHeicToJpeg(file, function(jpegFile) {
        applyPhoto(idx, jpegFile || file);
        if (done) done();
      });
    } else {
      applyPhoto(idx, file);
      if (done) done();
    }
  }

  function handlePhoto(idx, file) {
    var isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
                 /\.hei[cf]$/i.test(file.name);
    if (isHeic) {
      convertHeicToJpeg(file, function(jpegFile) {
        if (jpegFile) { handlePhoto(idx, jpegFile); } else { applyPhoto(idx, file); }
      });
      return;
    }
    applyPhoto(idx, file);
  }

  function convertHeicToJpeg(file, callback) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function() {
      try {
        var canvas = document.createElement('canvas');
        canvas.width  = img.naturalWidth;
        canvas.height = img.naturalHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob(function(blob) {
          if (blob) {
            var jpegName = file.name.replace(/\.hei[cf]$/i, '.jpg') || 'photo.jpg';
            callback(new File([blob], jpegName, {type: 'image/jpeg'}));
          } else { callback(null); }
        }, 'image/jpeg', 0.92);
      } catch(e) { URL.revokeObjectURL(url); callback(null); }
    };
    img.onerror = function() { URL.revokeObjectURL(url); callback(null); };
    img.src = url;
  }

  function applyPhoto(idx, file) {
    if (photos[idx]&&photos[idx].url) URL.revokeObjectURL(photos[idx].url);
    var url = URL.createObjectURL(file);
    photos[idx] = {file:file, url:url, panX:0, panY:0};

    var cell    = document.querySelector('.cc-cell[data-idx="'+idx+'"]');
    var cellImg = g('cc-cell-img-'+idx);
    var cellCtrl= g('cc-cell-controls-'+idx);
    var cellPh  = g('cc-placeholder-'+idx);
    if (cellImg)  { cellImg.src=url; cellImg.style.display='block'; }
    if (cellCtrl) cellCtrl.style.display='flex';
    if (cellPh)   cellPh.style.display='none';
    if (cell)     { cell.classList.add('has-photo'); cell.classList.remove('cc-cell--missing'); }

    var posterImg = g('cc-poster-img-'+idx);
    if (posterImg) {
      posterImg.src=url; posterImg.style.display='block';
      posterImg.style.filter = FILTER_CSS[state.filter]||'none';
      applyCanvasFilterToCell(idx);
      applyPanToPreview(idx);
    }

    var grid=g('cc-photo-grid'), prog=g('cc-upload-progress'), shuf=g('cc-shuffle-row');
    if (grid&&grid.style.display==='none') grid.style.display='';
    if (prog&&prog.style.display==='none') prog.style.display='';
    if (shuf&&shuf.style.display==='none') shuf.style.display='';

    updateUploadCount();
    setupCellDnd();
    scheduleWatermark();
  }

  function updateUploadCount() {
    var n=0;
    for (var i=0;i<state.gridCount;i++) { if(photos[i]) n++; }
    var ce=g('cc-upload-count'); if(ce) ce.textContent=n;
    var fe=g('cc-upload-progress-fill'); if(fe) fe.style.width=Math.round((n/state.gridCount)*100)+'%';
  }

  /* ── FILTER ───────────────────────────────────────────── */
  function applyFilterToAll() {
    var css = FILTER_CSS[state.filter]||'none';
    for (var i=0;i<12;i++) { var img=g('cc-poster-img-'+i); if(img) img.style.filter=css; }
    for (var j=0;j<state.gridCount;j++) { if(photos[j]) applyCanvasFilterToCell(j); }
    if (state.filter==='color') {
      document.querySelectorAll('.cc-poster-cell-filter-canvas').forEach(function(c){ c.remove(); });
    }
  }

  function applyCanvasFilterToCell(idx) {
    if (!photos[idx] || state.filter==='color') return;
    var posterCell = g('cc-poster-cell-'+idx);
    if (!posterCell) return;
    var src = photos[idx].url;
    var img = new Image();
    img.onload = function() {
      var fc = posterCell.querySelector('.cc-poster-cell-filter-canvas');
      if (!fc) {
        fc = document.createElement('canvas');
        fc.className = 'cc-poster-cell-filter-canvas';
        fc.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:2;pointer-events:none;';
        posterCell.appendChild(fc);
      }
      var cw = posterCell.offsetWidth||100, ch = posterCell.offsetHeight||100;
      fc.width=cw; fc.height=ch;
      var ctx = fc.getContext('2d');
      var p=photos[idx], iw=img.naturalWidth, ih=img.naturalHeight;
      var sc=Math.max(cw/iw,ch/ih), dw=iw*sc, dh=ih*sc;
      var ox=(cw-dw)/2-p.panX*(dw-cw)/2, oy=(ch-dh)/2-p.panY*(dh-ch)/2;
      ctx.drawImage(filteredCanvas(img,dw,dh,state.filter), ox, oy, dw, dh);
    };
    img.src = src;
  }

  /* ── BACKGROUND ───────────────────────────────────────── */
  function applyBackground() {
    var cfg=BG_CONFIG[state.bg]||BG_CONFIG.white;
    var poster=g('cc-poster'); if(!poster) return;
    poster.style.background=cfg.bg;
    var header=g('cc-poster-header'), hl=g('cc-p-headline'), sl=g('cc-p-subline');
    if(header) header.style.color=cfg.text;
    if(hl) hl.style.color=cfg.text;
    if(sl) sl.style.color=cfg.muted;
    document.querySelectorAll('.cc-poster-cell-empty').forEach(function(el){ el.style.background=cfg.cell; });
  }

  /* ── RATIO ────────────────────────────────────────────── */
  function updatePosterRatio(key) {
    var poster=g('cc-poster'); if(!poster) return;
    var cfg=SIZE_CONFIG[key]; if(!cfg) return;
    Object.keys(SIZE_CONFIG).forEach(function(k){ poster.classList.remove(SIZE_CONFIG[k].ratio); });
    poster.classList.add(cfg.ratio);
  }

  /* ── PREVIEW TEXT ─────────────────────────────────────── */
  // BUG FIX: preview now shows empty string for blank optional fields (subline),
  // and uses consistent fallbacks that match what renderPosterCanvas draws.
  function updatePreview() {
    var v=getValues();
    var pN=g('cc-p-names'),pD=g('cc-p-date'),pH=g('cc-p-headline'),pS=g('cc-p-subline');
    if(pN) pN.textContent = v.names;
    if(pD) pD.textContent = v.date;
    // BUG FIX: use same fallback as canvas render ('forever starts here'), not a different string
    if(pH) pH.textContent = v.headline || 'forever starts here';
    // BUG FIX: subline is optional — blank stays blank in both preview and canvas
    if(pS) pS.textContent = v.subline ? v.subline.toUpperCase() : '';
  }

  function getValues() {
    var n1=(g('cc-name1')&&g('cc-name1').value.trim().toUpperCase())||'';
    var sep=(g('cc-sep')&&g('cc-sep').value.trim())||'&';
    var n2=(g('cc-name2')&&g('cc-name2').value.trim().toUpperCase())||'';
    // Show placeholder names in preview only when both are blank (before user types)
    var namesDisplay = (n1 || n2)
      ? ((n1||'NAME 1')+' '+sep+' '+(n2||'NAME 2'))
      : 'AHMED & SARA';
    return {
      names:    namesDisplay,
      date:     (g('cc-date')&&g('cc-date').value.trim())     || '04.18.25',
      headline: (g('cc-headline')&&g('cc-headline').value.trim()) || '',
      subline:  (g('cc-subline')&&g('cc-subline').value.trim())   || '',
    };
  }

  /* ── VARIANT ──────────────────────────────────────────── */
  function resolveVariant() {
    var variants=window.ccVariants, vi=g('cc-variant-id'), pd=g('cc-price-display'), pc=g('cc-price-compare'), ab=g('cc-atc-btn');
    if(!variants||!vi) return;
    var names=Object.keys(state.selectedOptions), found=null;
    for (var i=0;i<variants.length;i++) {
      var v=variants[i];
      if (names.every(function(n,idx){ return v['option'+(idx+1)]===state.selectedOptions[n]; })) { found=v; break; }
    }
    if(!found) return;
    vi.value=found.id;
    if(pd) pd.textContent=(found.price/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})+' EGP';
    if(pc) {
      if(found.compareAt&&found.compareAt>found.price) { pc.textContent=(found.compareAt/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})+' EGP'; pc.style.display=''; }
      else pc.style.display='none';
    }
    if(ab&&!ab.dataset.sparkBusy) { ab.disabled=!found.available; ab.textContent=found.available?'🛒 Add to Cart':'Out of Stock'; }
  }

  /* ── WATERMARK ────────────────────────────────────────── */
  function scheduleWatermark() {
    if(watermarkRaf) cancelAnimationFrame(watermarkRaf);
    watermarkRaf = requestAnimationFrame(drawWatermarkOverlay);
  }
  function drawWatermarkOverlay() {
    watermarkRaf = null;
    for (var i = 0; i < state.gridCount; i++) {
      var canvas = g('cc-cell-wm-' + i);
      var cell   = g('cc-poster-cell-' + i);
      if (!canvas || !cell) continue;
      var W = cell.offsetWidth, H = cell.offsetHeight;
      if (!W || !H) continue;
      var dpr = window.devicePixelRatio || 1;
      canvas.width  = W * dpr; canvas.height = H * dpr;
      canvas.style.width  = W + 'px'; canvas.style.height = H + 'px';
      canvas.style.display = 'block';
      var ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
      drawWatermark(ctx, W, H);
    }
  }
  function drawWatermark(ctx,W,H) {
    ctx.save();
    var fontSize = Math.max(8, Math.round(W * 0.08));
    ctx.font         = 'bold ' + fontSize + 'px sans-serif';
    ctx.fillStyle    = 'rgba(80,80,80,0.28)';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    var text  = 'SPARK PREVIEW';
    var angle = -Math.PI / 6;
    var textW = ctx.measureText(text).width;
    var stepX = textW + fontSize * 1.5;
    var stepY = fontSize * 2.5;
    ctx.translate(W / 2, H / 2);
    ctx.rotate(angle);
    var d = Math.ceil(Math.sqrt(W * W + H * H));
    for (var row = -d; row < d; row += stepY) {
      for (var col = -d; col < d; col += stepX) {
        ctx.fillText(text, col, row);
      }
    }
    ctx.restore();
  }

  /* ── ADJUST MODAL ─────────────────────────────────────── */
  function openAdjustModal(idx) {
    var modal=g('cc-adjust-modal');
    if(!modal||!photos[idx]) return;
    state.adjustIdx=idx;
    var t=g('cc-adjust-title'); if(t) t.textContent='Adjust Photo '+(idx+1);
    modal.style.display='flex'; document.body.style.overflow='hidden';
    var p=photos[idx];
    if(!adjustImg||adjustImg._src!==p.url) {
      adjustImg=new Image(); adjustImg._src=p.url;
      adjustImg.onload=function(){ requestAnimationFrame(drawAdjustCanvas); };
      adjustImg.src=p.url;
    } else { requestAnimationFrame(drawAdjustCanvas); }
  }
  function closeAdjustModal() {
    var modal=g('cc-adjust-modal');
    if(modal) modal.style.display='none';
    document.body.style.overflow='';
    if(state.adjustIdx>=0) applyPanToPreview(state.adjustIdx);
    state.adjustIdx=-1;
  }
  function drawAdjustCanvas() {
    if(!adjustCanvas||!adjustCtx||!adjustImg||!adjustImg.complete) return;
    if(state.adjustIdx<0) return;
    var CW=(adjustCanvas.parentElement&&adjustCanvas.parentElement.offsetWidth)||320;
    if(CW<100) CW=320;
    var CH=CW, dpr=window.devicePixelRatio||1;
    adjustCanvas.width=CW*dpr; adjustCanvas.height=CH*dpr;
    adjustCanvas.style.width=CW+'px'; adjustCanvas.style.height=CH+'px';
    adjustCtx.save(); adjustCtx.scale(dpr,dpr);
    var p=photos[state.adjustIdx];
    var iw=adjustImg.naturalWidth, ih=adjustImg.naturalHeight;
    var sc=Math.max(CW/iw,CH/ih), dw=iw*sc, dh=ih*sc;
    adjustCtx.fillStyle='#000'; adjustCtx.fillRect(0,0,CW,CH);
    adjustCtx.drawImage(adjustImg,(CW-dw)/2-p.panX*(dw-CW)/2,(CH-dh)/2-p.panY*(dh-CH)/2,dw,dh);
    var cfg=SIZE_CONFIG[state.currentSize]||SIZE_CONFIG[DEFAULT_SIZE];
    var szX=safePx(CW,cfg.wCm), szY=safePx(CH,cfg.hCm);
    adjustCtx.strokeStyle='rgba(255,255,255,0.5)'; adjustCtx.lineWidth=1.5; adjustCtx.setLineDash([5,4]);
    adjustCtx.strokeRect(szX,szY,CW-szX*2,CH-szY*2);
    adjustCtx.restore();
  }

  /* ── DRAG ─────────────────────────────────────────────── */
  function onDragStart(e) {
    if(state.adjustIdx<0||!photos[state.adjustIdx]) return;
    if(e.target!==adjustCanvas) return;
    drag.active=true;
    var pt=e.touches?e.touches[0]:e;
    drag.startX=pt.clientX; drag.startY=pt.clientY;
    drag.startPanX=photos[state.adjustIdx].panX; drag.startPanY=photos[state.adjustIdx].panY;
  }
  function onDragMove(e) {
    if(!drag.active) return;
    if(e.cancelable) e.preventDefault();
    var pt=e.touches?e.touches[0]:e;
    var CW=adjustCanvas?(adjustCanvas.offsetWidth||320):320;
    var CH=adjustCanvas?(adjustCanvas.offsetHeight||320):320;
    var p=photos[state.adjustIdx];
    p.panX=clamp(drag.startPanX-(pt.clientX-drag.startX)/CW*2);
    p.panY=clamp(drag.startPanY-(pt.clientY-drag.startY)/CH*2);
    drawAdjustCanvas();
  }
  function onDragEnd() { drag.active=false; }

  /* ── SHUFFLE ──────────────────────────────────────────── */
  function shufflePhotos() {
    var n = state.gridCount;
    for (var i = n - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      if (i !== j) swapPhotos(i, j);
    }
  }

  /* ── DRAG AND DROP REORDER ───────────────────────────── */
  var dnd = { dragIdx: -1 };

  function initDragDrop() { setupCellDnd(); }

  function setupCellDnd() {
    document.querySelectorAll('.cc-cell').forEach(function(cell) {
      if (cell._dndBound) return;
      cell._dndBound = true;
      var idx = parseInt(cell.dataset.idx);

      cell.setAttribute('draggable', 'true');
      cell.addEventListener('dragstart', function(e) {
        if (!photos[idx]) { e.preventDefault(); return; }
        dnd.dragIdx = idx; cell.classList.add('cc-dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(idx));
      });
      cell.addEventListener('dragend', function() {
        cell.classList.remove('cc-dragging'); clearDragOver(); dnd.dragIdx = -1;
      });
      cell.addEventListener('dragover', function(e) {
        if (dnd.dragIdx < 0 || dnd.dragIdx === idx) return;
        e.preventDefault(); e.dataTransfer.dropEffect = 'move';
        clearDragOver(); cell.classList.add('cc-drag-over');
      });
      cell.addEventListener('dragleave', function(e) {
        if (!cell.contains(e.relatedTarget)) cell.classList.remove('cc-drag-over');
      });
      cell.addEventListener('drop', function(e) {
        e.preventDefault(); cell.classList.remove('cc-drag-over');
        var from = dnd.dragIdx, to = idx;
        if (from < 0 || from === to) return;
        swapPhotos(from, to); dnd.dragIdx = -1;
      });

      var touchClone = null, touchFrom = -1;
      cell.addEventListener('touchstart', function(e) {
        var handle = e.target.closest('.cc-drag-handle');
        if (!handle) return;
        if (!photos[idx]) return;
        touchFrom = idx; cell.classList.add('cc-dragging');
        var rect = cell.getBoundingClientRect();
        touchClone = cell.cloneNode(true);
        touchClone.style.cssText = [
          'position:fixed','width:'+rect.width+'px','height:'+rect.height+'px',
          'top:'+rect.top+'px','left:'+rect.left+'px','opacity:0.85',
          'pointer-events:none','z-index:9998','border-radius:6px','overflow:hidden',
          'box-shadow:0 8px 24px rgba(0,0,0,0.25)','transform:scale(1.05)','transition:none',
        ].join(';');
        document.body.appendChild(touchClone);
      }, { passive: true });

      cell.addEventListener('touchmove', function(e) {
        if (touchFrom < 0) return;
        e.preventDefault();
        var touch = e.touches[0];
        if (touchClone) {
          var rect = touchClone.getBoundingClientRect();
          touchClone.style.left = (touch.clientX - rect.width/2)+'px';
          touchClone.style.top  = (touch.clientY - rect.height/2)+'px';
        }
        clearDragOver();
        touchClone && (touchClone.style.display = 'none');
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        touchClone && (touchClone.style.display = '');
        var target = el && el.closest('.cc-cell');
        if (target && target !== cell) target.classList.add('cc-drag-over');
      }, { passive: false });

      cell.addEventListener('touchend', function(e) {
        if (touchFrom < 0) return;
        var touch = e.changedTouches[0];
        cell.classList.remove('cc-dragging');
        if (touchClone) { document.body.removeChild(touchClone); touchClone = null; }
        clearDragOver();
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        var target = el && el.closest('.cc-cell');
        if (target && target !== cell) {
          var toIdx = parseInt(target.dataset.idx);
          if (!isNaN(toIdx) && toIdx !== touchFrom) swapPhotos(touchFrom, toIdx);
        }
        touchFrom = -1;
      }, { passive: true });
    });
  }

  function clearDragOver() {
    document.querySelectorAll('.cc-drag-over').forEach(function(el){ el.classList.remove('cc-drag-over'); });
  }

  /* ── SWAP PHOTOS ─────────────────────────────────────── */
  function swapPhotos(a, b) {
    var tmp = photos[a]; photos[a] = photos[b]; photos[b] = tmp;
    [a, b].forEach(function(idx) {
      var cell     = document.querySelector('.cc-cell[data-idx="'+idx+'"]');
      var cellImg  = g('cc-cell-img-'+idx);
      var cellCtrl = g('cc-cell-controls-'+idx);
      var cellPh   = g('cc-placeholder-'+idx);
      var postImg  = g('cc-poster-img-'+idx);
      if (photos[idx]) {
        if (cellImg)  { cellImg.src = photos[idx].url; cellImg.style.display = 'block'; }
        if (cellCtrl) cellCtrl.style.display = 'flex';
        if (cellPh)   cellPh.style.display   = 'none';
        if (cell)     cell.classList.add('has-photo');
        if (postImg)  {
          postImg.src = photos[idx].url; postImg.style.display = 'block';
          postImg.style.filter = FILTER_CSS[state.filter] || 'none';
          applyCanvasFilterToCell(idx); applyPanToPreview(idx);
        }
      } else {
        if (cellImg)  { cellImg.src = ''; cellImg.style.display = 'none'; }
        if (cellCtrl) cellCtrl.style.display = 'none';
        if (cellPh)   cellPh.style.display   = 'flex';
        if (cell)     cell.classList.remove('has-photo');
        if (postImg)  { postImg.src = ''; postImg.style.display = 'none'; }
      }
    });
    scheduleWatermark();
  }

  function applyPanToPreview(idx) {
    var img=g('cc-poster-img-'+idx);
    if(!img||!photos[idx]) return;
    var p=photos[idx];
    img.style.objectPosition=((p.panX+1)/2*100).toFixed(1)+'% '+((p.panY+1)/2*100).toFixed(1)+'%';
  }

  /* ── CANVAS RENDER ────────────────────────────────────── */
  function renderPosterCanvas(W, H, withWatermark, callback) {
    var cfg   = SIZE_CONFIG[state.currentSize]||SIZE_CONFIG[DEFAULT_SIZE];
    var bgCfg = BG_CONFIG[state.bg]||BG_CONFIG.white;
    var v     = getValues();
    var cols  = 3, rows = state.gridCount/3;

    var poster      = g('cc-poster');
    var headerEl    = g('cc-poster-header');
    var footerEl    = g('cc-poster-footer');
    var headlineEl  = g('cc-p-headline');
    var sublineEl   = g('cc-p-subline');

    var domW   = poster  ? poster.offsetWidth  : 340;
    var s      = W / domW;

    var headerH, footerH, headlineOffsetInFooter, sublineOffsetInFooter;
    if (headerEl && footerEl && poster) {
      var pRect  = poster.getBoundingClientRect();
      var hRect  = headerEl.getBoundingClientRect();
      var fRect  = footerEl.getBoundingClientRect();
      var hlRect = headlineEl ? headlineEl.getBoundingClientRect() : null;
      var slRect = sublineEl  ? sublineEl.getBoundingClientRect()  : null;
      headerH = (hRect.bottom - pRect.top) * s;
      footerH = (pRect.bottom - fRect.top) * s;
      headlineOffsetInFooter = hlRect ? (hlRect.top - fRect.top + hlRect.height/2) * s : 18 * s;
      sublineOffsetInFooter  = slRect ? (slRect.top - fRect.top + slRect.height/2) * s : footerH - 6 * s;
    } else {
      headerH = 28 * s;
      footerH = 52 * s;
      headlineOffsetInFooter = 18 * s;
      sublineOffsetInFooter  = 40 * s;
    }

    var PAD      = PAD_PX * s;
    var GRID_TOP = PAD + headerH;
    var GRID_BOT = H - PAD - footerH;
    var GRID_H   = GRID_BOT - GRID_TOP;
    var GRID_W   = W - PAD * 2;
    var GAP      = GAP_PX * s;
    var CELL_W   = (GRID_W - GAP*(cols-1)) / cols;
    var CELL_H   = (GRID_H - GAP*(rows-1)) / rows;

    var loaded=0, needed=0, imgEls=[];
    for (var i=0;i<state.gridCount;i++) {
      if (photos[i]) {
        needed++;
        (function(idx){
          var img=new Image();
          img.onload  = function(){ imgEls[idx]=img; loaded++; if(loaded===needed) go(); };
          img.onerror = function(){               loaded++; if(loaded===needed) go(); };
          img.src=photos[idx].url;
        })(i);
      }
    }
    if (needed===0) go();

    function go() {
      var canvas=document.createElement('canvas');
      canvas.width=W; canvas.height=H;
      var ctx=canvas.getContext('2d');

      ctx.fillStyle=bgCfg.bg; ctx.fillRect(0,0,W,H);

      for (var row=0;row<rows;row++) {
        for (var col=0;col<cols;col++) {
          var idx=row*cols+col;
          var cx=PAD+col*(CELL_W+GAP);
          var cy=GRID_TOP+row*(CELL_H+GAP);
          ctx.fillStyle=bgCfg.cell; ctx.fillRect(cx,cy,CELL_W,CELL_H);
          if (imgEls[idx]&&photos[idx]) {
            ctx.save(); ctx.beginPath(); ctx.rect(cx,cy,CELL_W,CELL_H); ctx.clip();
            var img=imgEls[idx];
            var iw=img.naturalWidth, ih=img.naturalHeight;
            var sc2=Math.max(CELL_W/iw,CELL_H/ih);
            var dw=iw*sc2, dh=ih*sc2;
            var pho=photos[idx];
            var ox=(CELL_W-dw)/2-pho.panX*(dw-CELL_W)/2;
            var oy=(CELL_H-dh)/2-pho.panY*(dh-CELL_H)/2;
            var filteredImg = filteredCanvas(img, dw, dh, state.filter);
            ctx.drawImage(filteredImg, cx+ox, cy+oy, dw, dh);
            ctx.restore();
          }
        }
      }

      // Header
      ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillStyle=bgCfg.text;
      ctx.font='300 '+Math.round(9*s)+'px "DM Sans",sans-serif';
      ctx.fillText(v.names+'   |   '+v.date, W/2, PAD+headerH/2);

      // Footer — headline
      // BUG FIX: use same fallback as updatePreview so WYSIWYG is exact
      var footerTop = GRID_BOT;
      ctx.font='500 '+Math.round(26*s)+'px "Caveat",cursive';
      ctx.fillStyle=bgCfg.text;
      ctx.fillText(v.headline || 'forever starts here', W/2, footerTop+headlineOffsetInFooter);

      // Footer — subline: BUG FIX: blank when empty (no forced fallback)
      if (v.subline) {
        ctx.font='300 '+Math.round(7*s)+'px "DM Sans",sans-serif';
        ctx.fillStyle=bgCfg.muted;
        ctx.fillText(v.subline.toUpperCase(), W/2, footerTop+sublineOffsetInFooter);
      }

      if(withWatermark) drawWatermark(ctx,W,H);
      callback(canvas);
    }
  }

  /* ── PRODUCE FILES ────────────────────────────────────── */
  function renderPosterToFile(callback) {
    var cfg    = SIZE_CONFIG[state.currentSize]||SIZE_CONFIG[DEFAULT_SIZE];
    var CM     = 1/2.54;
    var fullW  = Math.round(cfg.wCm*CM*MIN_DPI);
    var fullH  = Math.round(cfg.hCm*CM*MIN_DPI);
    var prevW  = 220;
    var prevH  = Math.round(prevW*cfg.hCm/cfg.wCm);

    renderPosterCanvas(fullW, fullH, false, function(fullCanvas){
      if(!fullCanvas){ callback(null,null); return; }
      fullCanvas.toBlob(function(blob){
        if(!blob){ callback(null,null); return; }
        var cleanFile=new File([blob],'collage-poster.jpg',{type:'image/jpeg'});
        renderPosterCanvas(prevW, prevH, true, function(prevCanvas){
          if(!prevCanvas){ callback(cleanFile,null); return; }
          prevCanvas.toBlob(function(blob2){
            callback(cleanFile, blob2?new File([blob2],'collage-poster-preview.jpg',{type:'image/jpeg'}):null);
          },'image/jpeg',0.65);
        });
      },'image/jpeg',0.93);
    });
  }

  /* ── SUBMIT ───────────────────────────────────────────── */
  function handleSubmit(e) {
    e.preventDefault(); e.stopImmediatePropagation();
    var missing=[];
    for(var i=0;i<state.gridCount;i++){ if(!photos[i]) missing.push(i+1); }
    if(missing.length>0){ showError('Please upload all '+state.gridCount+' photos. Missing: '+missing.join(', ')+'.'); goToStep(1); return; }
    // BUG FIX: validate mandatory text fields on submit too
    var name1 = (g('cc-name1') && g('cc-name1').value.trim()) || '';
    var name2 = (g('cc-name2') && g('cc-name2').value.trim()) || '';
    var headline = (g('cc-headline') && g('cc-headline').value.trim()) || '';
    if (!name1 || !name2) {
      if (!name1 && g('cc-name1')) g('cc-name1').classList.add('cc-field--error');
      if (!name2 && g('cc-name2')) g('cc-name2').classList.add('cc-field--error');
      showError('Please enter both names.'); goToStep(2); return;
    }
    if (!headline) {
      if (g('cc-headline')) g('cc-headline').classList.add('cc-field--error');
      showError('Please enter a headline.'); goToStep(2); return;
    }
    var vi=g('cc-variant-id');
    if(!vi||!vi.value){ showError('Please select all options.'); return; }
    var atcBtn=g('cc-atc-btn');
    if(atcBtn&&atcBtn.dataset.sparkBusy) return;
    hideError(); buildReview();
    var spin=showSpinner(atcBtn);
    spin.label('Rendering poster…');
    setTimeout(function(){
      renderPosterToFile(function(cleanFile, previewFile){
        if(!cleanFile){ showError('Could not render poster. Please try again.'); spin.restore(); return; }
        var hp=g('cc-hidden-photo'), pp=g('cc-preview-photo');
        try{ var dt1=new DataTransfer(); dt1.items.add(cleanFile); hp.files=dt1.files; }
        catch(err){ showError('Upload not supported. Please use Chrome or Safari.'); spin.restore(); return; }
        if(previewFile&&pp){ try{ var dt2=new DataTransfer(); dt2.items.add(previewFile); pp.files=dt2.files; }catch(ex){} }
        spin.label('Uploading…');
        fetch('/cart/add.js',{method:'POST',credentials:'same-origin',body:new FormData(g('cc-product-form'))})
          .then(function(res){ if(!res.ok) return res.json().then(function(d){throw new Error(d.description||d.message||'Cart error');}); return res.json(); })
          .then(function(){
            spin.label('Added! ✓');
            setTimeout(function(){ spin.restore(); },1200);
            resetCustomizer();
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-poster' });
              setTimeout(function () {
                var cd = document.querySelector('cart-drawer');
                if (cd) { cd.classList.remove('is-empty'); if (cd.open) cd.open(); }
              }, 300);
            } else {
              var cartIcon = document.querySelector('#cart-icon-bubble, [data-cart-toggle], .js-drawer-open-right');
              if (cartIcon) cartIcon.click();
            }
          })
          .catch(function(err){ showError(err.message||'Something went wrong.'); spin.restore(); });
      });
    },50);
  }

  /* ── RESET ────────────────────────────────────────────── */
  function resetCustomizer() {
    for(var i=0;i<12;i++){
      if(photos[i]&&photos[i].url) URL.revokeObjectURL(photos[i].url);
      photos[i]=null;
      var ci=g('cc-cell-img-'+i); if(ci){ci.src='';ci.style.display='none';}
      var cc=g('cc-cell-controls-'+i); if(cc) cc.style.display='none';
      var cp=g('cc-placeholder-'+i); if(cp) cp.style.display='flex';
      var cell=document.querySelector('.cc-cell[data-idx="'+i+'"]');
      if(cell) cell.classList.remove('has-photo','cc-cell--missing');
      var pi=g('cc-poster-img-'+i); if(pi){pi.src='';pi.style.display='none';}
      try{ var ri=g('cc-replace-'+i); if(ri) ri.files=new DataTransfer().files; }catch(e){}
    }
    var bi=g('cc-bulk-input'); try{ if(bi) bi.files=new DataTransfer().files; }catch(e){}
    var grid=g('cc-photo-grid'), prog=g('cc-upload-progress'), shuf=g('cc-shuffle-row');
    if(grid) grid.style.display='none';
    if(prog) prog.style.display='none';
    if(shuf) shuf.style.display='none';

    ['cc-name1','cc-name2','cc-date','cc-headline','cc-subline'].forEach(function(id){
      var el=g(id);
      if(el) { el.value=''; el.classList.remove('cc-field--error'); }
    });
    var sep=g('cc-sep'); if(sep) sep.value='&';

    state.filter='bw'; state.bg='white'; state.gridCount=9;
    document.querySelectorAll('.cc-filter-btn').forEach(function(b){ b.classList.toggle('active',b.dataset.filter==='bw'); });
    document.querySelectorAll('.cc-bg-btn').forEach(function(b){ b.classList.toggle('active',b.dataset.bg==='white'); });
    document.querySelectorAll('.cc-count-btn').forEach(function(b){ b.classList.toggle('active',b.dataset.count==='9'); });
    setGridCount(9); applyBackground();

    var seen={};
    document.querySelectorAll('.cc-pill[data-option]').forEach(function(pill){
      var opt=pill.dataset.option;
      if(!seen[opt]){ seen[opt]=true; pill.classList.add('active'); state.selectedOptions[opt]=pill.dataset.value;
        if(pill.dataset.value in SIZE_CONFIG){ state.currentSize=pill.dataset.value; updatePosterRatio(pill.dataset.value); }
      } else pill.classList.remove('active');
    });
    try{ var hp=g('cc-hidden-photo'); if(hp) hp.files=new DataTransfer().files; }catch(e){}
    try{ var pp=g('cc-preview-photo'); if(pp) pp.files=new DataTransfer().files; }catch(e){}
    adjustImg=null; state.adjustIdx=-1;
    hideError(); updatePreview(); resolveVariant(); goToStep(1); scheduleWatermark();
  }

  /* ── HELPERS ──────────────────────────────────────────── */
  function showError(msg){ var el=g('cc-error'); if(!el) return; el.textContent=msg; el.classList.add('visible'); el.scrollIntoView({behavior:'smooth',block:'nearest'}); }
  function hideError(){ var el=g('cc-error'); if(el) el.classList.remove('visible'); }

  /* ── BOOT ─────────────────────────────────────────────── */
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();

})();